import { COUNTRIES } from 'constants/countries';

export const getCountryLabelFromCode = (code: string) =>
  COUNTRIES.find(country => country.code === code.toUpperCase())?.label;
